import React from "react";
export const StaffContext = React.createContext(false);
